import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { UserBoat } from '@regatta-replay/types';

interface BoatContextState {
  /** Currently active boat (highlighted in results, drives "My Races" filter) */
  activeBoatId: string | null;
  ownedBoats: UserBoat[];
  crewBoats: UserBoat[];
  loaded: boolean;

  setActiveBoat: (boatId: string | null) => void;
  setBoats: (owned: UserBoat[], crewing: UserBoat[]) => void;
  getActiveBoat: () => UserBoat | null;
}

export const useBoatContextStore = create<BoatContextState>()(
  persist(
    (set, get) => ({
      activeBoatId: null,
      ownedBoats: [],
      crewBoats: [],
      loaded: false,

      setActiveBoat: (boatId) => set({ activeBoatId: boatId }),

      setBoats: (owned, crewing) => {
        const state = get();
        // Auto-select first owned boat if no active boat
        const activeBoatId =
          state.activeBoatId && [...owned, ...crewing].some((b) => b.boatId === state.activeBoatId)
            ? state.activeBoatId
            : owned[0]?.boatId ?? crewing[0]?.boatId ?? null;

        set({ ownedBoats: owned, crewBoats: crewing, activeBoatId, loaded: true });
      },

      getActiveBoat: () => {
        const { activeBoatId, ownedBoats, crewBoats } = get();
        if (!activeBoatId) return null;
        return (
          ownedBoats.find((b) => b.boatId === activeBoatId) ??
          crewBoats.find((b) => b.boatId === activeBoatId) ??
          null
        );
      },
    }),
    { name: 'regatta-zone-boat-context' },
  ),
);
